// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

// Afidium
import { ButtonModule } from '../../fields/button/button.module';
import { QuantityFieldsetModule } from '../../fieldsets/quantity-fieldset/quantity-fieldset.module';
import { PriceFieldsetModule } from '../../fieldsets/price-fieldset/price-fieldset.module';
import { CarrierFieldsetModule } from '../../fieldsets/carrier-fieldset/carrier-fieldset.module';
import { ChipsFieldModule } from '../../fields/chips-field/chips-field.module';
import { KeywordFieldsetModule } from '../../fieldsets/keyword-fieldset/keyword-fieldset.module';
import { ComboboxFieldModule } from "libraries/module/formbuilder/fields/combobox-field/combobox-field.module";

import { SearchAirTripFormComponent } from './searchAirTrip.component';
import { FlexibilityService } from './services/flexibility.service';
import { PermissionModule } from "libraries/permission/permission.module";
import { LabelModule } from "libraries/service/label/label.module";
import { DateModule } from "../../fields/date/date.module";
import { SegmentAirFieldsetModule } from "../../fieldsets/segment-air-fieldset/segment-air-fieldset.module";
import { HostFieldsetModule } from "../../fieldsets/host-fieldset/host-fieldset.module";
import { MultiselectModule } from "../../fields/multiselect/multiselect.module";
import { ConfigurationResourceModule } from "libraries/service/resources/configuration/configurationResource.module";
import { SamResourceModule } from 'libraries/service/resources/sam/samResource.module';
import { UserAuthModule } from 'libraries/service/user-auth/user-auth.module';
import { CheckboxFieldModule } from "../../fields/checkbox-field/checkbox-field.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { AirportSelectModule } from "libraries/component/airport-select/airport-select.module";

@NgModule({
    declarations: [
        SearchAirTripFormComponent,
    ],
    imports: [
        ButtonModule,
        CarrierFieldsetModule,
        ChipsFieldModule,
        ComboboxFieldModule,
        CheckboxFieldModule,
        CommonModule,
        DateModule,
        HostFieldsetModule,
        KeywordFieldsetModule,
        LabelModule,
        MultiselectModule,
        PermissionModule,
        PriceFieldsetModule,
        QuantityFieldsetModule,
        ReactiveFormsModule,
        SegmentAirFieldsetModule,
        ConfigurationResourceModule,
        SamResourceModule,
        UserAuthModule,
        FontAwesomeModule,
        AirportSelectModule,
    ],
    exports: [
        SearchAirTripFormComponent,
    ],
    providers: [
        FlexibilityService,
    ],
})
export class SearchAirTripModule {
}
